<template>
  <div>
    <v-tabs>
      <v-tab href="#tab-1">移機硬體 </v-tab>
      <v-tab href="#tab-2">{{ $t('quotation_item_return_tab_new_item') }} </v-tab>
      <v-tab href="#tab-3">{{ $t('quotation_item_return_tab_month_item') }}</v-tab>
      <v-tab href="#tab-4">{{ $t('quotation_item_tab_pay_item') }}</v-tab>
      <v-tab href="#tab-5">{{ $t('quotation_tab_second') }}</v-tab>
      <v-tab-item value="tab-1">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="moveItemDataTableHeaders"
              :items="computedMoveItemList"
              :search="searchMoveItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              disable-pagination
              hide-default-footer
              item-key="Index"
              show-select
              v-model="selectedMoveItems"
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{
                    $t('quotation_item_remove_car_customer_fix_title')
                  }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchMoveItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    @click="deleteMoveItems"
                    :disabled="isAllTextFieldDisabled || selectedMoveItems.length === 0"
                  >
                    {{ $t('common_delete') }}
                  </v-btn>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    @click="isShowMoveItemDialog = true"
                    :disabled="isAllTextFieldDisabled"
                  >
                    {{ $t('common_new') }}
                  </v-btn>
                  <v-dialog v-model="isShowMoveItemDialog" v-if="isShowMoveItemDialog" persistent>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ title }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialog">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('installation_notice_item_buy_or_rent')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="editedMoveItem.BuyOrRentType"
                                    :items="allBuyOrRentType"
                                    item-text="Name"
                                    item-value="Type"
                                    required
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    ref="buyOrRentTypeAutocomplete"
                                    @keyup.enter="setBuyOrRentType"
                                    :error-messages="errors[0]"
                                    :disabled="
                                      editedMoveItem.Type === 'Z100000000' ||
                                        editedMoveItemIndex !== -1
                                    "
                                    @change="changeBuyOrRentType"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('installation_notice_item_buy_or_rent') }}
                                    </template>
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <quotation-item-for-repair-price-autocomplete
                                  :fatherEditedItem="editedMoveItem"
                                  :editedItemIndex="editedMoveItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedMoveItem.CustomerDeviceType"
                                  @setEditedItem="setEditedMoveItem"
                                  v-if="
                                    editedMoveItemIndex === -1 &&
                                      (editedMoveItem.BuyOrRentType === 2 ||
                                        editedMoveItem.BuyOrRentType === 3)
                                  "
                                  @keyupEnter="focusNextInput"
                                  refName="returnItemAutocomplete"
                                />
                                <quotation-item-autocomplete
                                  :fatherEditedItem="editedMoveItem"
                                  :editedItemIndex="editedMoveItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :customerDeviceType="editedMoveItem.CustomerDeviceType"
                                  @setEditedItem="setEditedMoveItem"
                                  v-else-if="
                                    editedMoveItemIndex === -1 && editedMoveItem.BuyOrRentType === 1
                                  "
                                  refName="returnItemAutocomplete"
                                  @keyupEnter="focusNextInput"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedMoveItem.Number"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedMoveItem.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  name="每台拆數量"
                                  :rules="{
                                    required: true,
                                    regex: /^[0-9]+$/,
                                    is: isCheckMoveItemRemoveQuantity,
                                  }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedMoveItem.RemoveQuantity"
                                    required
                                    @keyup.enter="focusNextInput"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      每台拆數量
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  name="每台裝數量"
                                  :rules="{
                                    required: true,
                                    regex: /^[0-9]+$/,
                                    is: isCheckMoveItemReturnQuantity,
                                  }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedMoveItem.ReturnQuantity"
                                    required
                                    @keyup.enter="focusNextInput"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      每台裝數量
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedMoveItem.Unit"
                                    required
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <v-autocomplete
                                  v-model="editedMoveItem.InstallPosition"
                                  :items="allInstallPositionType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  ref="installPositionAutocomplete"
                                  @keyup.enter="setInstallPosition"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="4" lg="4">
                                <v-checkbox
                                  v-model="editedMoveItem.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                  :disabled="editedMoveItem.BuyOrRentType === 1"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedMoveItem.CustomerDeviceType"
                                  :items="customerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedMoveItem.IsCustomerDevice"
                                  ref="deviceTypeAutocomplete"
                                  @keyup.enter="setCustomerMoveDeviceType"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedMoveItem.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedMoveItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedMoveItem">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    @click="isShowMoveCarEditedBomDialog = true"
                    :disabled="isAllTextFieldDisabled"
                  >
                    {{ $t('quotation_item_new_install_new_bom_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowMoveCarEditedBomDialog"
                    v-if="isShowMoveCarEditedBomDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ title }}</span>
                      </v-card-title>

                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="bomRepairItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                                <ValidationProvider
                                  :name="$t('installation_notice_item_buy_or_rent')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-autocomplete
                                    v-model="editedMoveCarBomItem.BuyOrRentType"
                                    :items="allBuyOrRentType"
                                    item-text="Name"
                                    item-value="Type"
                                    required
                                    :loading-text="$t('common_get_data')"
                                    :no-data-text="$t('common_no_results')"
                                    ref="buyOrRentTypeAutocomplete"
                                    @keyup.enter="setBuyOrRentType"
                                    :error-messages="errors[0]"
                                    @change="changeBuyOrRentType"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('installation_notice_item_buy_or_rent') }}
                                    </template>
                                  </v-autocomplete>
                                </ValidationProvider>
                              </v-col>
                              <v-col
                                cols="12"
                                sm="6"
                                md="3"
                                xl="3"
                                lg="3"
                                v-if="editedMoveCarBomItem.BuyOrRentType === 1"
                              >
                                <quotation-bom-autocomplete
                                  :fatherEditedItem="editedMoveCarBomItem"
                                  :editedItemIndex="editedMoveItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedMoveCarBomItem.CustomerDeviceType"
                                  @setBomItem="setBomItem"
                                  v-if="editedMoveItemIndex === -1"
                                  @keyupEnter="focusNextInput"
                                  refName="bomNameAutocomplete"
                                />
                              </v-col>
                              <v-col cols="12" sm="6" md="3" xl="3" lg="3" v-else>
                                <quotation-bom-for-repair-price-autocomplete
                                  :fatherEditedItem="editedMoveCarBomItem"
                                  :editedItemIndex="editedMoveItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedMoveCarBomItem.CustomerDeviceType"
                                  @setBomItem="setBomItem"
                                  v-if="editedMoveItemIndex === -1"
                                  @keyupEnter="focusNextInput"
                                  refName="bomNameAutocomplete"
                                />
                              </v-col>
                              <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedMoveCarBomItem.Describe"
                                  disabled
                                  label="主設備描述"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                                <ValidationProvider
                                  name="每台拆數量"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedMoveCarBomItem.RemoveQuantity"
                                    required
                                    :disabled="editedMoveItemIndex !== -1"
                                    @keyup.enter="focusNextInput"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      每台拆數量
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="3" xl="3" lg="3">
                                <ValidationProvider
                                  name="每台裝數量"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedMoveCarBomItem.ReturnQuantity"
                                    required
                                    :disabled="editedMoveItemIndex !== -1"
                                    @keyup.enter="focusNextInput"
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      每台裝數量
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="3" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedMoveCarBomItem.InstallPositions"
                                  :items="allInstallPositionType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  small-chips
                                  multiple
                                  @change="setInstallPositionQuantity"
                                  @keydown.enter="setKeyDownAutocomplete"
                                  @keyup.enter="setKeyUpAutocomplete"
                                  ref="installPositionsAutocomplete"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" xl="3" lg="3">
                                <v-checkbox
                                  v-model="editedMoveCarBomItem.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                  :disabled="editedMoveCarBomItem.BuyOrRentType === 1"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedMoveCarBomItem.CustomerDeviceType"
                                  :items="customerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedMoveCarBomItem.IsCustomerDevice"
                                  ref="deviceTypeAutocomplete"
                                  @keyup.enter="setCustomerDeviceType"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn
                          color="red darken-1"
                          text
                          @click="closeMoveCarEditedBomDialog"
                          :disabled="isAllTextFieldDisabled"
                        >
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="addMoveCarBomItem">
                          {{ $t('common_confirm') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeleteMoveItemDialog"
                    :deleteMessage="'quotation_item_remove_car_customer_fix_delete_title'"
                    @closeDelete="closeDeleteReturnItem"
                    @confirmDelete="confirmDeleteReturnItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-btn
                  icon
                  @click="isShowEditedMoveItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-pencil
                  </v-icon>
                </v-btn>
                <v-btn
                  icon
                  @click="isShowDeleteMoveItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  <v-icon small>
                    mdi-delete
                  </v-icon>
                </v-btn>
              </template>
              <template v-slot:[`item.InstallPosition`]="{ item }">
                {{ turnData(item.InstallPosition) }}
              </template>
              <template v-slot:[`item.BuyOrRentType`]="{ item }">
                {{ turnBuyOrRentType(item.BuyOrRentType) }}
              </template>
              <template v-slot:[`item.Move`]="{ item, index }">
                <v-icon
                  @click="upMoveItem(item)"
                  v-if="index !== 0"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-arrow-up-drop-circle-outline
                </v-icon>
                <v-icon
                  @click="downMoveItem(item)"
                  v-if="index !== computedMoveItemList.length - 1"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-arrow-down-drop-circle-outline
                </v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-2">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="newItemDataTableHeaders"
              :items="newItemList"
              :search="searchNewItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              disable-pagination
              hide-default-footer
              item-key="Name"
              :expanded.sync="expanded"
              :single-expand="singleExpand"
            >
              <template v-slot:item="{ item, expand, isExpanded, index }">
                <tr>
                  <td class="text-start" v-if="item.Number">
                    {{ item.TempStockQuantity }}
                  </td>
                  <td class="text-start" v-else></td>
                  <td class="text-start">
                    {{ item.Number }}
                  </td>
                  <td class="text-start">
                    {{ item.Name }}
                  </td>
                  <td class="text-end">
                    {{ item.Quantity }}
                  </td>
                  <td class="text-end">
                    {{ item.BuyQuantity }}
                  </td>
                  <td class="text-end">
                    {{ item.RentQuantity }}
                  </td>
                  <td class="text-start">
                    {{ item.Unit }}
                  </td>
                  <td class="text-end">
                    {{ item.TotalQuantity }}
                  </td>
                  <td class="text-end">
                    {{ item.Price }}
                  </td>
                  <td class="text-end">
                    {{ item.Discount }}
                  </td>
                  <td class="text-end">
                    {{ item.DiscountPrice }}
                  </td>
                  <td class="text-end">
                    {{ item.TotalPrice }}
                  </td>
                  <td class="text-end" v-if="item.Number !== ''">
                    {{ item.WarrantyPeriod }}
                  </td>
                  <td class="text-end" v-else></td>
                  <td class="text-start">
                    {{ turnPositionsData(item.InstallPositions) }}
                  </td>
                  <td class="text-center">
                    <v-icon v-if="item.IsCustomerDevice">
                      mdi-check
                    </v-icon>
                    <v-icon v-else>
                      mdi-window-close
                    </v-icon>
                  </td>
                  <td class="text-end" v-if="item.Number !== ''">
                    {{ item.RepairPrice }}
                  </td>
                  <td class="text-end" v-else></td>
                  <td class="text-end" v-if="item.Number !== ''">
                    {{ item.RepairWarrantyPeriod }}
                  </td>
                  <td class="text-end" v-else></td>
                  <td class="text-start">
                    {{ item.Remark }}
                  </td>
                  <td class="text-center">
                    <v-icon
                      small
                      class="mr-2"
                      @click="isShowEditNewItemDialogBtn(item, index, -1)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="isShowDeleteNewItemDialogBtn(item, index, -1)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                  <td>
                    <v-icon
                      @click="upNewItem(item)"
                      v-if="index !== 0"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-arrow-up-drop-circle-outline
                    </v-icon>
                    <v-icon
                      @click="downNewItem(item)"
                      v-if="index !== newItemList.length - 1"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-arrow-down-drop-circle-outline
                    </v-icon>
                  </td>
                  <td v-if="item.Number"></td>
                  <td v-if="!item.Number" class="text-start">
                    <v-icon @click="expand(!isExpanded)" v-if="isExpanded">
                      mdi-chevron-up
                    </v-icon>
                    <v-icon @click="expand(!isExpanded)" v-else>
                      mdi-chevron-down
                    </v-icon>
                  </td>
                </tr>
              </template>

              <template v-slot:expanded-item="{ item, index }">
                <tr v-for="(field, idx) in item.BomItems" :key="field.Number">
                  <td class="text-start">
                    {{ field.TempStockQuantity }}
                  </td>
                  <td class="text-start">
                    {{ field.Number }}
                  </td>
                  <td class="text-start">
                    {{ field.Name }}
                  </td>
                  <td class="text-end">
                    {{ field.Quantity }}
                  </td>
                  <td class="text-end">
                    {{ field.BuyQuantity }}
                  </td>
                  <td class="text-end">
                    {{ field.RentQuantity }}
                  </td>
                  <td class="text-start">
                    {{ field.Unit }}
                  </td>
                  <td class="text-end">
                    {{ field.TotalQuantity }}
                  </td>
                  <td class="text-end">
                    {{ field.Price }}
                  </td>
                  <td class="text-end">
                    {{ field.Discount }}
                  </td>
                  <td class="text-end">
                    {{ field.DiscountPrice }}
                  </td>
                  <td class="text-end">
                    {{ field.TotalPrice }}
                  </td>
                  <td class="text-end">
                    {{ field.WarrantyPeriod }}
                  </td>
                  <td class="text-start">
                    {{ turnPositionsData(field.InstallPositions) }}
                  </td>
                  <td class="text-center">
                    <v-icon v-if="field.IsCustomerDevice">
                      mdi-check
                    </v-icon>
                    <v-icon v-else>
                      mdi-window-close
                    </v-icon>
                  </td>

                  <td class="text-end">
                    {{ field.RepairPrice }}
                  </td>
                  <td class="text-end">
                    {{ field.RepairWarrantyPeriod }}
                  </td>
                  <td class="text-start">
                    {{ field.Remark }}
                  </td>
                  <td class="text-center">
                    <v-icon
                      small
                      class="mr-2"
                      @click="isShowEditNewItemDialogBtn(field, index, idx)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-pencil
                    </v-icon>
                    <v-icon
                      small
                      @click="isShowDeleteNewItemDialogBtn(field, index, idx)"
                      :disabled="isAllTextFieldDisabled"
                    >
                      mdi-delete
                    </v-icon>
                  </td>
                  <td></td>
                  <td></td>
                </tr>
              </template>

              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{ $t('quotation_item_return_car_title') }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchNewItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    dark
                    class="mb-2 ml-8"
                    @click="isShowEditNewItemDialog = true"
                    :disabled="isAllTextFieldDisabled"
                  >
                    {{ $t('quotation_item_new_install_new_item_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditNewItemDialog"
                    v-if="isShowEditNewItemDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ $t('quotation_item_return_card_title') }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedNewItem.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedNewItem.CustomerDeviceType"
                                  :items="computedItemCustomerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedNewItem.IsCustomerDevice"
                                  @keyup.enter="setCustomerDeviceType"
                                  ref="customerDeviceTypeAutocomplete"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <quotation-item-for-repair-price-autocomplete
                                  :fatherEditedItem="editedNewItem"
                                  :editedItemIndex="editedNewItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedNewItem.CustomerDeviceType"
                                  @setEditedItem="setEditedNewItem"
                                  v-if="editedNewItemIndex === -1"
                                  refName="newItemAutocomplete"
                                  @keyupEnter="focusNextInput"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedNewItem.Number"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.Quantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-text-field
                                  v-model="editedNewItem.TempStockQuantity"
                                  disabled
                                  label="庫存數量"
                                >
                                </v-text-field>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col
                                cols="12"
                                sm="6"
                                md="4"
                                lg="3"
                                xl="3"
                                v-if="editedNewItem.Type !== 'Z100000000'"
                              >
                                <ValidationProvider
                                  :name="$t('quotation_item_buy_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.BuyQuantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_buy_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_rent_quantity')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.RentQuantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_rent_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="computedTotalQuantity"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.Price"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.Discount"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣後單價"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.DiscountPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣後單價
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="computedTotalPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_warranty_period')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.WarrantyPeriod"
                                    :error-messages="errors[0]"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_warranty_period') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedNewItem.InstallPositions"
                                  :items="allInstallPositionType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  small-chips
                                  multiple
                                  @keydown.enter="setKeyDownAutocomplete"
                                  @keyup.enter="setKeyUpAutocomplete"
                                  ref="installPositionsAutocomplete"
                                ></v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_repair_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.RepairPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_repair_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_repair_warranty_period')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.RepairWarrantyPeriod"
                                    :label="$t('quotation_item_repair_warranty_period')"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_repair_warranty_period') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>

                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedNewItem.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedNewItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedNewItem">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeleteNewItemDialog"
                    :deleteMessage="'quotation_item_delete_item_dialog_title'"
                    @closeDelete="closeDeleteNewItem"
                    @confirmDelete="confirmDeleteNewItem"
                  />
                  <v-dialog v-model="isShowEditNewItemBomDialog" persistent>
                    <template v-slot:activator="{ on, attrs }">
                      <v-btn
                        color="primary"
                        dark
                        class="mb-2 ml-8"
                        v-bind="attrs"
                        v-on="on"
                        :disabled="isAllTextFieldDisabled"
                      >
                        {{ $t('quotation_item_new_install_new_bom_btn') }}
                      </v-btn>
                    </template>
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ newItemDialogTitle }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogBom">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedNewItem.IsCustomerDevice"
                                  :label="$t('quotation_item_is_customer_device')"
                                  @change="changeIsCustomerDevice"
                                ></v-checkbox>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedNewItem.CustomerDeviceType"
                                  :items="computedBomCustomerDeviceTypeList"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('engineer_item_customer_device_type')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  v-if="editedNewItem.IsCustomerDevice"
                                  @keyup.enter="setBomCustomerDeviceType"
                                  ref="bomCustomerDeviceTypeAutocomplete"
                                ></v-autocomplete>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <quotation-bom-for-repair-price-autocomplete
                                  :fatherEditedItem="editedNewItem"
                                  :editedItemIndex="editedNewItemIndex"
                                  :itemName="'quotation_item_number'"
                                  :repairCustomerId="repairCustomerId"
                                  :customerDeviceType="editedNewItem.CustomerDeviceType"
                                  @setBomItem="setNewItemBomItem"
                                  v-if="editedNewItemIndex === -1"
                                  @keyupEnter="focusNextInput"
                                  refName="bomNameAutocomplete"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedNewItem.Name"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.Quantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_buy_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.BuyQuantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_buy_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_rent_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.RentQuantity"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_rent_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="computedTotalQuantity"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.Price"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.Discount"
                                    :error-messages="errors[0]"
                                    @change="changeMoney"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣後單價"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedNewItem.DiscountPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣後單價
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="computedTotalPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-autocomplete
                                  v-model="editedNewItem.InstallPositions"
                                  :items="allInstallPositionType"
                                  item-text="Name"
                                  item-value="Type"
                                  :label="$t('quotation_item_install_position')"
                                  :loading-text="$t('common_get_data')"
                                  :no-data-text="$t('common_no_results')"
                                  small-chips
                                  multiple
                                  @change="setNewInstallPositionQuantity"
                                  @keydown.enter="setKeyDownAutocomplete"
                                  @keyup.enter="setKeyUpAutocomplete"
                                  ref="installPositionsAutocomplete"
                                ></v-autocomplete>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <v-checkbox
                                  v-model="editedNewItem.IsOptionalItem"
                                  label="選配"
                                ></v-checkbox>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedNewItem.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedNewItemBom">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedNewItemBom">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeleteNewItemBomDialog"
                    :deleteMessage="'common_delete'"
                    @closeDelete="closeDeleteNewItemBom"
                    @confirmDelete="confirmDeleteNewItemBom"
                  />
                </v-toolbar>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-3">
        <move-month-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :carQuantity="carQuantity"
          :allPayType="allPayType"
          :allPayQuantityType="allPayQuantityType"
          :repairCustomerId="repairCustomerId"
          @setAllMoveMonth="setAllMoveMonth"
          @setMonthItemIndex="setMonthItemIndex"
          @setMoveMonthItem="setMoveMonthItem"
          @deleteMoveMonthItem="deleteMoveMonthItem"
        />
      </v-tab-item>
      <v-tab-item value="tab-4">
        <v-card flat>
          <v-card-text>
            <v-data-table
              :headers="payItemDataTableHeaders"
              :items="payItemList"
              :search="searchPayItem"
              class="elevation-1"
              :no-data-text="$t('common_no_data')"
              :no-results-text="$t('common_no_results')"
              item-key="Name"
              disable-pagination
              hide-default-footer
            >
              <template v-slot:top>
                <v-toolbar flat>
                  <v-toolbar-title>{{
                    $t('quotation_item_return_tool_bar_title')
                  }}</v-toolbar-title>
                  <v-spacer></v-spacer>
                  <v-text-field
                    v-model="searchPayItem"
                    append-icon="mdi-magnify"
                    :label="$t('quotation_item_new_install_search')"
                    single-line
                    hide-details
                    clearable
                  ></v-text-field>
                  <v-btn
                    color="primary"
                    class="mb-2 ml-8"
                    :disabled="isAllTextFieldDisabled"
                    @click="openPayItem"
                  >
                    {{ $t('quotation_item_new_install_new_item_btn') }}
                  </v-btn>
                  <v-dialog
                    v-model="isShowEditPayItemDialog"
                    v-if="isShowEditPayItemDialog"
                    persistent
                  >
                    <v-card>
                      <v-card-title>
                        <span class="text-h5">{{ $t('quotation_item_return_pay') }}</span>
                      </v-card-title>
                      <v-card-text>
                        <v-container>
                          <ValidationObserver ref="dialogPayItem">
                            <v-row>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <pay-item-autocomplete
                                  :fatherEditedItem="editedPayItem"
                                  :editedItemIndex="editedPayItemIndex"
                                  :itemName="'quotation_item_number'"
                                  @setEditedPayItem="setEditedPayItem"
                                  v-if="editedPayItemIndex === -1"
                                  refName="payItemAutocomplete"
                                  @keyupEnter="focusNextInput"
                                />
                                <ValidationProvider
                                  :name="$t('quotation_item_number')"
                                  rules="required"
                                  v-slot="{ errors }"
                                  v-else
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Number"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_number') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_name')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Name"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_name') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_car_quantity')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.BuyQuantity"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_car_quantity') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_unit')"
                                  rules="required"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Unit"
                                    disabled
                                    :error-messages="errors[0]"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_unit') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Price"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.Discount"
                                    :error-messages="errors[0]"
                                    @change="changePayTotal"
                                    @keyup.enter="focusNextInput"
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  name="折扣後單價"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.DiscountPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      折扣後單價
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                              <v-col cols="12" sm="6" md="4" lg="3" xl="3">
                                <ValidationProvider
                                  :name="$t('quotation_item_total_price')"
                                  :rules="{ required: true, regex: /^[0-9]+$/ }"
                                  v-slot="{ errors }"
                                >
                                  <v-text-field
                                    v-model="editedPayItem.TotalPrice"
                                    :error-messages="errors[0]"
                                    disabled
                                  >
                                    <template v-slot:label>
                                      <span class="red--text">
                                        <strong>* </strong>
                                      </span>
                                      {{ $t('quotation_item_total_price') }}
                                    </template>
                                  </v-text-field>
                                </ValidationProvider>
                              </v-col>
                            </v-row>
                            <v-row>
                              <v-col>
                                <v-textarea
                                  outlined
                                  :label="$t('quotation_item_remark')"
                                  v-model="editedPayItem.Remark"
                                ></v-textarea>
                              </v-col>
                            </v-row>
                          </ValidationObserver>
                        </v-container>
                      </v-card-text>
                      <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="red darken-1" text @click="closeEditedPayItem">
                          {{ $t('common_cancel') }}
                        </v-btn>
                        <v-btn color="green darken-1" text @click="saveEditedPayItem">
                          {{ $t('common_save') }}
                        </v-btn>
                      </v-card-actions>
                    </v-card>
                  </v-dialog>
                  <delete-dialog
                    :isAllTextFieldDisable="false"
                    :isLoadingSaveBtn="false"
                    :isShowDeleteDialog="isShowDeletePayItemDialog"
                    :deleteMessage="'quotation_item_delete_item_dialog_title'"
                    @closeDelete="closeDeletePayItem"
                    @confirmDelete="confirmDeletePayItem"
                  />
                </v-toolbar>
              </template>
              <template v-slot:[`item.Edit`]="{ item }">
                <v-icon
                  small
                  class="mr-2"
                  @click="isShowEditPayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-pencil
                </v-icon>
                <v-icon
                  small
                  @click="isShowDeletePayItemDialogBtn(item)"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-delete
                </v-icon>
              </template>
              <template v-slot:[`item.Move`]="{ item, index }">
                <v-icon
                  @click="upPayItem(item)"
                  v-if="index !== 0"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-arrow-up-drop-circle-outline
                </v-icon>
                <v-icon
                  @click="downPayItem(item)"
                  v-if="index !== payItemList.length - 1"
                  :disabled="isAllTextFieldDisabled"
                >
                  mdi-arrow-down-drop-circle-outline
                </v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-tab-item>
      <v-tab-item value="tab-5">
        <new-discount-setting
          :isAllTextFieldDisabled="isAllTextFieldDisabled"
          :monthItemList="monthItemList"
          :discountItemList="discountItemList"
          @setAllDiscount="setAllDiscount"
          @deleteDiscountItem="deleteDiscountItem"
          @setDiscountItem="setDiscountItem"
          @setDiscountItemIndex="setDiscountItemIndex"
        />
      </v-tab-item>
    </v-tabs>
  </div>
</template>

<script>
import {
  HttpBom,
  HttpInstallationAcceptance,
  HttpQuotation,
  HttpInstallPosition,
  HttpTempStock
} from '@/js/http-Manager'
import { extend } from 'vee-validate'
import { regex, is } from 'vee-validate/dist/rules'
import DeleteDialog from '@/components/DeleteDialog.vue'
import PayItemAutocomplete from '@/components/PayItemAutocomplete.vue'
import { ItemInstallPositionType } from '@/js/ItemInstallPositionType'
import QuotationItemForRepairPriceAutocomplete from '@/components/Quotation/ItemAutocomplete/QuotationItemForRepairPriceAutocomplete.vue'
import { BuyOrRentType } from '@/js/BuyOrRentType'
import QuotationItemAutocomplete from '@/components/Quotation/ItemAutocomplete/QuotationItemAutocomplete.vue'
import QuotationBomForRepairPriceAutocomplete from '@/components/Quotation/BomAutocomplete/QuotationBomForRepairPriceAutocomplete.vue'
import QuotationBomAutocomplete from '@/components/Quotation/BomAutocomplete/QuotationBomAutocomplete.vue'
import NewDiscountSetting from '@/components/Quotation/DiscountItem/NewDiscountSetting.vue'
import MoveMonthSetting from '@/components/Quotation/MonthItem/MoveMonthSetting.vue'

extend('regex', regex)

export default {
  components: {
    DeleteDialog,
    PayItemAutocomplete,
    QuotationItemForRepairPriceAutocomplete,
    QuotationItemAutocomplete,
    QuotationBomForRepairPriceAutocomplete,
    QuotationBomAutocomplete,
    NewDiscountSetting,
    MoveMonthSetting
  },
  name: 'ReturnCar',
  data: () => ({
    tempStock: {},
    selectedMoveItems: [],
    isShowDeleteMoveItemDialog: false,
    editedMoveItemIndex: -1,
    searchMoveItem: '',
    isShowMoveItemDialog: false,
    editedMoveItem: {
      BomName: '',
      Id: '',
      Number: '',
      Name: '',
      Unit: '',
      RemoveQuantity: 0,
      ReturnQuantity: 0,
      BuyOrRentType: 0,
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      IsCustomerDevice: false,
      InstallPosition: 0,
      Custody: 0,
      Remark: '',
      HasSerialNumber: false,
      CustomerDeviceType: 0
    },
    defaultMoveItem: {
      BomName: '',
      ItemId: '',
      Number: '',
      Name: '',
      Unit: '',
      RemoveQuantity: 0,
      ReturnQuantity: 0,
      BuyOrRentType: 0,
      SerialNumber: {
        ItemId: '',
        Number: '',
        IsUsed: false,
        AcceptanceNumber: '',
        RepairNumber: ''
      },
      IsCustomerDevice: false,
      InstallPosition: 0,
      Custody: 0,
      Remark: '',
      HasSerialNumber: false,
      CustomerDeviceType: 0
    },
    searchNewItem: '',
    editedNewItemIndex: -1,
    isShowEditNewItemDialog: false,
    isShowDeleteNewItemDialog: false,
    isShowEditNewItemBomDialog: false,
    isShowDeleteNewItemBomDialog: false,
    editedNewBomItemIndex: -1,
    editedNewItem: {
      Sort: '',
      Number: '',
      Name: '',
      Quantity: 0,
      BuyQuantity: 0,
      RentQuantity: 0,
      Unit: '',
      TotalQuantity: 0,
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      TotalPrice: 0,
      WarrantyPeriod: 0,
      InstallPositions: [],
      MonthNumber: '',
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      Remark: '',
      TempStockQuantity: 0,
      BomItems: []
    },
    defaultNewItem: {
      Sort: '',
      Number: '',
      Name: '',
      Quantity: 0,
      BuyQuantity: 0,
      RentQuantity: 0,
      Unit: '',
      TotalQuantity: 0,
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      TotalPrice: 0,
      WarrantyPeriod: 0,
      InstallPositions: [],
      MonthNumber: '',
      IsCustomerDevice: false,
      CustomerDeviceType: 0,
      Remark: '',
      TempStockQuantity: 0,
      BomItems: []
    },
    bomList: [],

    expanded: [],
    singleExpand: true,
    isLoading: false,
    bomSource: null,
    searchPayItem: '',
    isShowEditPayItemDialog: false,
    editedPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    defaultPayItem: {
      Id: '',
      Number: '',
      Name: '',
      BuyQuantity: 0,
      Unit: '',
      Price: 0,
      DiscountPrice: 0,
      Discount: 0,
      Remark: '',
      TotalPrice: 0
    },
    editedPayItemIndex: -1,
    isShowDeletePayItemDialog: false,
    allInstallPositionType: [],
    allBuyOrRentType: [],
    customerDeviceTypeList: [],
    computedTotalQuantity: 0,
    computedTotalPrice: 0,

    tempInstallPositions: [],
    editedMoveCarBomItem: {
      Name: '',
      Describe: '',
      RemoveQuantity: 0,
      ReturnQuantity: 0,
      BuyOrRentType: 0,
      BomItems: [],
      IsCustomerDevice: false,
      CustomerDeviceType: 0
    },
    defaultMoveCarBomItem: {
      Name: '',
      Describe: '',
      RemoveQuantity: 0,
      ReturnQuantity: 0,
      BuyOrRentType: 0,
      BomItems: [],
      IsCustomerDevice: false,
      CustomerDeviceType: 0
    },
    isShowMoveCarEditedBomDialog: false,
    moveBomList: [],
    regexPrice: /^[0-9]+$/,
    regexQuantity: /^[0-9]+$/
  }),
  async mounted () {
    await this.getMoveBoms()
    await this.getAllInstallPositionType()
    await this.getBuyOrRentType()
    await this.getCustomerDeviceType()
    extend('is', {
      ...is,
      message: () => '只能填寫0、1'
    })
  },
  computed: {
    computedMoveItemList () {
      let array = []
      this.moveItemList.forEach((element, index) => {
        array.push(Object.assign({ Index: index }, element))
      })
      return array
    },
    moveItemDataTableHeaders () {
      return [
        { text: this.$t('installation_notice_item_main_name'), align: 'start', value: 'BomName' },
        { text: '主設備描述', align: 'start', value: 'BomDescribe' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        {
          text: this.$t('installation_notice_item_buy_or_rent'),
          align: 'center',
          value: 'BuyOrRentType'
        },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: '拆數量', align: 'end', value: 'RemoveQuantity' },
        { text: '裝數量', align: 'end', value: 'ReturnQuantity' },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        },
        {
          text: this.$t('quotation_item_serialnumber'),
          align: 'start',
          value: 'SerialNumber.Number'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'IsCustomerDevice'
        },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false }
      ]
    },
    newItemDataTableHeaders () {
      return [
        { text: '實際庫存', align: 'start', value: 'TempStockQuantity' },
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_item_quantity'), align: 'end', value: 'Quantity' },
        { text: this.$t('quotation_item_buy_quantity'), align: 'end', value: 'BuyQuantity' },
        { text: this.$t('quotation_item_rent_quantity'), align: 'end', value: 'RentQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_total_quantity'), align: 'end', value: 'TotalQuantity' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        { text: this.$t('quotation_item_warranty_period'), align: 'end', value: 'WarrantyPeriod' },
        {
          text: this.$t('quotation_item_install_position'),
          align: 'start',
          value: 'InstallPosition'
        },
        {
          text: this.$t('quotation_item_is_customer_device'),
          align: 'start',
          value: 'IsCustomerDevice'
        },
        { text: this.$t('quotation_item_repair_price'), align: 'end', value: 'RepairPrice' },
        {
          text: this.$t('quotation_item_repair_warranty_period'),
          align: 'end',
          value: 'RepairWarrantyPeriod'
        },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false },
        { text: '', value: 'data-table-expand', sortable: false }
      ]
    },
    newItemDialogTitle () {
      return this.editedNewItemIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },
    newItemList () {
      let array = []
      this.fatherNewItemList.forEach((element, index) => {
        element.Index = index
        if (element.Number) {
          element.TempStockQuantity =
            this.fatherTempStockList.find((tempStock) => tempStock.ItemNumber === element.Number)
              ?.CurrentQuantity || 0
        } else {
          element.BomItems.forEach((bomItem) => {
            bomItem.TempStockQuantity =
              this.fatherTempStockList.find((tempStock) => tempStock.ItemNumber === bomItem.Number)
                ?.CurrentQuantity || 0
          })
        }
        array.push(element)
      })
      return array
    },

    payItemDataTableHeaders () {
      return [
        { text: this.$t('quotation_item_number'), align: 'start', value: 'Number' },
        { text: this.$t('quotation_item_name'), align: 'start', value: 'Name' },
        { text: this.$t('quotation_car_quantity'), align: 'end', value: 'BuyQuantity' },
        { text: this.$t('quotation_item_unit'), align: 'start', value: 'Unit' },
        { text: this.$t('quotation_item_price'), align: 'end', value: 'Price' },
        { text: '折扣', align: 'end', value: 'Discount' },
        { text: '折扣後單價', align: 'end', value: 'DiscountPrice' },
        { text: this.$t('quotation_item_total_price'), align: 'end', value: 'TotalPrice' },
        { text: this.$t('quotation_item_remark'), align: 'start', value: 'Remark' },
        { text: this.$t('common_edit'), align: 'center', value: 'Edit', sortable: false },
        { text: '調動', align: 'center', value: 'Move', sortable: false }
      ]
    },
    title () {
      return this.editedMoveItemIndex === -1 ? this.$t('common_new') : this.$t('common_edit')
    },

    headerProps () {
      return { sortByText: this.$t('installation_acceptance_header_sort') }
    },
    isCheckMoveItemRemoveQuantity () {
      return (
        this.editedMoveItem.RemoveQuantity * 1 > 1 &&
        (this.editedMoveItem.HasSerialNumber || this.editedMoveItem.InstallPosition > 0)
      )
    },
    isCheckMoveItemReturnQuantity () {
      return (
        this.editedMoveItem.ReturnQuantity * 1 > 1 &&
        (this.editedMoveItem.HasSerialNumber || this.editedMoveItem.InstallPosition > 0)
      )
    },
    computedItemCustomerDeviceTypeList () {
      let array = []
      if (this.editedNewItem.Number.includes('RA400')) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (this.editedNewItem.HasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }

      return array
    },
    computedBomCustomerDeviceTypeList () {
      let array = []
      let isRA400 = this.editedNewItem.BomItems.findIndex((x) => x.Number.includes('RA400')) !== -1
      let hasSerialNumber = this.editedNewItem.BomItems.findIndex((x) => x.HasSerialNumber) !== -1
      if (isRA400) {
        array = this.customerDeviceTypeList.filter((x) => x.Type !== 3)
      } else if (hasSerialNumber) {
        let obj = this.customerDeviceTypeList.find((x) => x.Type === 3)
        array.push(obj)
      } else {
        array = this.customerDeviceTypeList
      }
      return array
    }
  },
  watch: {
    // carQuantity (val) {
    //   if (this.monthItemList.length > 0) {
    //     this.monthItemList.forEach((element) => {
    //       element.RentQuantity = val
    //       element.TotalPrice = val * element.Price * element.Quantity
    //     })
    //   }
    //   if (this.payItemList.length > 0) {
    //     this.payItemList.forEach((element) => {
    //       element.BuyQuantity = val
    //     })
    //   }
    //   this.$emit('computedAmt')
    // }
  },
  methods: {
    setNewInstallPositionQuantity () {
      this.editedNewItem.Quantity = this.editedNewItem.InstallPositions.length
      this.editedNewItem = JSON.parse(JSON.stringify(this.editedNewItem))
      this.changeMoney()
    },
    setNewItemBomItem (val) {
      if (val) {
        this.editedNewItem.Quantity = 0
        this.editedNewItem.RentQuantity = 0
        this.editedNewItem.BuyQuantity = 0
        this.editedNewItem.TotalPrice = 0
        this.editedNewItem.TotalQuantity = 0
        this.editedNewItem.Id = val.Id
        this.editedNewItem.Price = val.Price
        this.editedNewItem.Name = val.Name
        this.editedNewItem.Number = val.Number
        this.editedNewItem.Unit = val.Unit
        this.editedNewItem.Describe = val.Describe
        this.editedNewItem.Remark = val.Remark
        this.editedNewItem.BomItems = val.BomItems

        if (this.editedNewItem.BomItems) {
          this.editedNewItem.BomItems.forEach((element) => {
            element.IsCustomerDevice = val.IsCustomerDevice
            element.CustomerDeviceType = val.CustomerDeviceType
            element.Quantity = element.Quantity * 1
            element.RentQuantity = 0
            element.BuyQuantity = 0
            element.TotalPrice = 0
            element.TotalQuantity = 0
          })
        }
      } else {
        this.editedNewItem.Quantity = 0
        this.editedNewItem.RentQuantity = 0
        this.editedNewItem.BuyQuantity = 0
        this.editedNewItem.TotalPrice = 0
        this.editedNewItem.TotalQuantity = 0
        this.editedNewItem.Id = ''
        this.editedNewItem.Price = 0
        this.editedNewItem.Name = ''
        this.editedNewItem.Number = ''
        this.editedNewItem.Unit = ''
        this.editedNewItem.Describe = ''
        this.editedNewItem.Remark = ''
        this.editedNewItem.BomItems = []
      }
    },
    setBomItem (val) {
      if (this.editedMoveCarBomItem) {
        this.editedMoveCarBomItem.Id = val.Id
        this.editedMoveCarBomItem.Name = val.Name
        this.editedMoveCarBomItem.Describe = val.Describe
        this.editedMoveCarBomItem.BomItems = val.BomItems
      } else {
        this.editedMoveCarBomItem.Id = ''
        this.editedMoveCarBomItem.Name = ''
        this.editedMoveCarBomItem.Describe = ''
        this.editedMoveCarBomItem.BomItems = []
      }

      this.editedMoveCarBomItem = JSON.parse(JSON.stringify(this.editedMoveCarBomItem))
    },
    deleteMoveItems () {
      let array = []
      this.computedMoveItemList.forEach((element) => {
        let isExist =
          this.selectedMoveItems.findIndex(
            (x) =>
              x.BomName === element.BomName &&
              x.InstallPosition === element.InstallPosition &&
              x.Id === element.Id
          ) !== -1
        if (!isExist) {
          array.push(element)
        }
      })

      this.$emit('setMove', array)
      this.selectedMoveItems = []
    },

    changeBuyOrRentType () {
      this.editedMoveItem.Name = ''
      this.editedMoveCarBomItem.Name = ''
      this.editedMoveCarBomItem.Id = ''
      this.editedMoveCarBomItem.Describe = ''
      this.editedMoveCarBomItem.BomItems = []
      this.editedMoveItem.Unit = ''
      if (this.editedMoveItem.BuyOrRentType === 1) {
        this.editedMoveItem.IsCustomerDevice = true
        this.editedMoveItem.CustomerDeviceType = 3
      } else if (this.editedMoveCarBomItem.BuyOrRentType === 1) {
        this.editedMoveCarBomItem.IsCustomerDevice = true
        this.editedMoveCarBomItem.CustomerDeviceType = 3
      }
    },
    setInstallPositionQuantity () {
      this.editedMoveCarBomItem.RemoveQuantity = this.editedMoveCarBomItem.InstallPositions.length
      this.editedMoveCarBomItem.ReturnQuantity = this.editedMoveCarBomItem.InstallPositions.length
      this.editedMoveCarBomItem = JSON.parse(JSON.stringify(this.editedMoveCarBomItem))
    },
    async getMoveBoms () {
      let response = await HttpBom.GetAllBoms()
      this.moveBomList = response.status === 200 ? response.data.Data : []
    },
    async addMoveCarBomItem () {
      const isValid = await this.$refs.bomRepairItem.validate()
      if (isValid) {
        this.computedMoveItemList.forEach((element) => {
          if (
            this.editedMoveCarBomItem.Id === element.BomId &&
            this.editedMoveCarBomItem.BuyOrRentType === element.BuyOrRentType
          ) {
            let index = this.editedMoveCarBomItem.BomItems.findIndex((x) => x.Id === element.Id)
            if (index !== -1) {
              if (
                this.editedMoveCarBomItem.InstallPositions &&
                this.editedMoveCarBomItem.InstallPositions.length > 0
              ) {
                let idx = this.editedMoveCarBomItem.InstallPositions.findIndex(
                  (x) => x === element.InstallPosition
                )
                if (idx !== -1) {
                  this.editedMoveCarBomItem.InstallPositions.splice(idx, 1)
                  this.editedMoveCarBomItem.RemoveQuantity--
                  this.editedMoveCarBomItem.ReturnQuantity--
                  if (this.editedMoveCarBomItem.InstallPositions.length === 0) {
                    this.editedMoveCarBomItem.BomItems.splice(index, 1)
                  }
                }
              } else {
                this.editedMoveCarBomItem.BomItems.splice(index, 1)
              }
            }
          }
        })

        if (this.editedMoveCarBomItem.BomItems.length !== 0) {
          if (
            this.editedMoveCarBomItem.InstallPositions &&
            this.editedMoveCarBomItem.InstallPositions.length > 0
          ) {
            this.editedMoveCarBomItem.InstallPositions.forEach((ele) => {
              this.editedMoveCarBomItem.BomItems.forEach((element) => {
                this.$emit('setMoveItemIndex', -1)
                this.$emit('setEditedMoveItem', {
                  BomName: this.editedMoveCarBomItem.Name,
                  BomId: this.editedMoveCarBomItem.Id,
                  BomDescribe: this.editedMoveCarBomItem.Describe,
                  Id: element.Id,
                  Number: element.Number,
                  Name: element.Name,
                  Unit: element.Unit,
                  RemoveQuantity:
                    this.editedMoveCarBomItem.RemoveQuantity * 1 === 0
                      ? 0
                      : (this.editedMoveCarBomItem.RemoveQuantity * element.Quantity * 1) /
                        this.editedMoveCarBomItem.InstallPositions.length,
                  ReturnQuantity:
                    this.editedMoveCarBomItem.ReturnQuantity * 1 === 0
                      ? 0
                      : (this.editedMoveCarBomItem.ReturnQuantity * element.Quantity * 1) /
                        this.editedMoveCarBomItem.InstallPositions.length,
                  BuyOrRentType: this.editedMoveCarBomItem.BuyOrRentType,
                  SerialNumber: {
                    ItemId: '',
                    Number: '',
                    IsUsed: false,
                    AcceptanceNumber: '',
                    RepairNumber: ''
                  },
                  IsCustomerDevice: this.editedMoveCarBomItem.IsCustomerDevice,
                  InstallPosition: ele,
                  Custody: 0,
                  Remark: '',
                  HasSerialNumber: element.HasSerialNumber,
                  CustomerDeviceType: this.editedMoveCarBomItem.CustomerDeviceType
                })
              })
            })
          } else {
            this.editedMoveCarBomItem.BomItems.forEach((element) => {
              this.$emit('setMoveItemIndex', -1)
              this.$emit('setEditedMoveItem', {
                BomName: this.editedMoveCarBomItem.Name,
                BomId: this.editedMoveCarBomItem.Id,
                BomDescribe: this.editedMoveCarBomItem.Describe,
                Id: element.Id,
                Number: element.Number,
                Name: element.Name,
                Unit: element.Unit,
                RemoveQuantity:
                  this.editedMoveCarBomItem.RemoveQuantity * 1 === 0
                    ? 0
                    : this.editedMoveCarBomItem.RemoveQuantity * element.Quantity,
                ReturnQuantity:
                  this.editedMoveCarBomItem.ReturnQuantity * 1 === 0
                    ? 0
                    : this.editedMoveCarBomItem.ReturnQuantity * element.Quantity,
                BuyOrRentType: this.editedMoveCarBomItem.BuyOrRentType,
                SerialNumber: {
                  ItemId: '',
                  Number: '',
                  IsUsed: false,
                  AcceptanceNumber: '',
                  RepairNumber: ''
                },
                IsCustomerDevice: this.editedMoveCarBomItem.IsCustomerDevice,
                InstallPosition: element.InstallPosition,
                Custody: 0,
                Remark: '',
                HasSerialNumber: element.HasSerialNumber,
                CustomerDeviceType: this.editedMoveCarBomItem.CustomerDeviceType
              })
            })
          }
        }
        this.closeMoveCarEditedBomDialog()
      }
    },
    closeMoveCarEditedBomDialog () {
      this.isShowMoveCarEditedBomDialog = false
      let str = JSON.stringify(this.defaultMoveCarBomItem)
      this.editedMoveCarBomItem = JSON.parse(str)
    },
    SetBomCustomerDeviceType (event) {
      this.$refs.bomCustomerDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.bomCustomerDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setBomName (event) {
      this.$refs.bomNameAutocomplete.isMenuActive = false
      this.$refs.bomNameAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setCustomerMoveDeviceType (event) {
      this.$refs.deviceTypeAutocomplete.isMenuActive = false
      this.$refs.deviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setCustomerDeviceType (event) {
      this.$refs.customerDeviceTypeAutocomplete.isMenuActive = false
      this.$refs.customerDeviceTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setInstallPosition (event) {
      this.$refs.installPositionAutocomplete.isMenuActive = false
      this.$refs.installPositionAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setBuyOrRentType (event) {
      this.$refs.buyOrRentTypeAutocomplete.isMenuActive = false
      this.$refs.buyOrRentTypeAutocomplete.isFocused = false
      this.focusNextInput(event)
    },
    setKeyDownAutocomplete () {
      ///  儲存keydown之前的Roles
      this.tempInstallPositions = this.editedNewItem.InstallPositions
    },
    setKeyUpAutocomplete (event) {
      this.$refs.installPositionsAutocomplete.isMenuActive = false
      this.$refs.installPositionsAutocomplete.isFocused = false
      ///  塞回keydown之前的Roles  給KeyUp的Model editedUser.Roles
      this.editedNewItem.InstallPositions = this.tempInstallPositions
      this.focusNextInput(event)
    },
    focusNextInput (event) {
      let form = document.getElementsByTagName('input')
      let targets = []
      for (let i = 0; i < form.length; i++) {
        if (
          form[i].type !== 'hidden' &&
          !form[i].disabled &&
          !form[i].readOnly &&
          form[i].type !== 'checkbox'
        ) {
          targets.push(form[i])
        }
      }
      let index = Array.prototype.indexOf.call(targets, event.target)
      if (index !== -1) {
        let next = index + 1
        if (next < targets.length) {
          targets[next].focus()
          targets[next].select()
        }
      }
    },
    downPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.payItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setAllPay', temp)
    },
    upPayItem (item) {
      let temp = JSON.parse(JSON.stringify(this.payItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setAllPay', temp)
    },

    downNewItem (item) {
      let temp = JSON.parse(JSON.stringify(this.newItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setNewItem', temp)
    },
    upNewItem (item) {
      let temp = JSON.parse(JSON.stringify(this.newItemList))
      let currentIndex = temp.findIndex((x) => x.Id === item.Id)
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setNewItem', temp)
    },
    downMoveItem (item) {
      let temp = JSON.parse(JSON.stringify(this.computedMoveItemList))
      let currentIndex = item.HasSerialNumber
        ? temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition &&
              x.SerialNumber.Number === item.SerialNumber.Number
        )
        : temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition
        )
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let nextObj = JSON.parse(JSON.stringify(temp[currentIndex + 1]))
      temp.splice(currentIndex + 1, 1, currentObj)
      temp.splice(currentIndex, 1, nextObj)
      this.$emit('setMove', temp)
    },
    upMoveItem (item) {
      let temp = JSON.parse(JSON.stringify(this.computedMoveItemList))
      let currentIndex = item.HasSerialNumber
        ? temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition &&
              x.SerialNumber.Number === item.SerialNumber.Number
        )
        : temp.findIndex(
          (x) =>
            x.Id === item.Id &&
              x.BomId === item.BomId &&
              x.InstallPosition === item.InstallPosition
        )
      let currentObj = JSON.parse(JSON.stringify(temp[currentIndex]))
      let preObj = JSON.parse(JSON.stringify(temp[currentIndex - 1]))
      temp.splice(currentIndex - 1, 1, currentObj)
      temp.splice(currentIndex, 1, preObj)
      this.$emit('setMove', temp)
    },

    changePayTotal () {
      if (
        this.regexPrice.test(this.editedPayItem.Price) &&
        this.regexQuantity.test(this.editedPayItem.BuyQuantity) &&
        this.regexQuantity.test(this.editedPayItem.Discount) &&
        this.regexQuantity.test(this.editedPayItem.DiscountPrice)
      ) {
        this.editedPayItem.DiscountPrice = this.editedPayItem.Price - this.editedPayItem.Discount
        this.editedPayItem.TotalPrice =
          this.editedPayItem.BuyQuantity * this.editedPayItem.DiscountPrice * 1
      }
    },
    turnBuyOrRentType (val) {
      return BuyOrRentType.BuyOrRentTypeName(val)
    },
    turnPositionsData (value) {
      if (value) {
        let str = []
        let temp = 0
        value.forEach((element) => {
          str.push(
            ItemInstallPositionType.getFormInstallPositionTypeName(
              element,
              this.allInstallPositionType
            )
          )
          temp++
        })
        str = JSON.stringify(str)
        str = str.replace('[', '').replace(']', '')
        for (let index = 0; index < temp * 2; index++) {
          str = str.replace('"', '')
        }
        return str
      }
    },
    changeMoney () {
      if (
        this.regexPrice.test(this.editedNewItem.Price) &&
        this.regexQuantity.test(this.editedNewItem.BuyQuantity) &&
        this.regexQuantity.test(this.editedNewItem.RentQuantity) &&
        this.regexQuantity.test(this.editedNewItem.Quantity) &&
        this.regexPrice.test(this.editedNewItem.Discount) &&
        this.regexPrice.test(this.editedNewItem.DiscountPrice)
      ) {
        this.computedTotalQuantity =
          this.editedNewItem.Quantity *
          (this.editedNewItem.RentQuantity * 1 + this.editedNewItem.BuyQuantity * 1)
        this.editedNewItem.TotalQuantity = this.computedTotalQuantity
        this.editedNewItem.DiscountPrice = this.editedNewItem.Price - this.editedNewItem.Discount
        this.computedTotalPrice =
          this.editedNewItem.DiscountPrice *
          this.editedNewItem.BuyQuantity *
          this.editedNewItem.Quantity
        this.editedNewItem.TotalPrice = this.computedTotalPrice
      }
    },
    async setEditedNewItem (val) {
      this.editedNewItem.Id = val.Id
      this.editedNewItem.Number = val.Number
      this.editedNewItem.Name = val.Name
      this.editedNewItem.Unit = val.Unit
      this.editedNewItem.Price = val.Price
      this.editedNewItem.IsMonthItem = val.IsMonthItem
      this.editedNewItem.HasSerialNumber = val.HasSerialNumber
      this.editedNewItem.IsDelete = val.IsDelete
      this.editedNewItem.StoreNo = val.StoreNo
      this.editedNewItem.RepairPrice = val.RepairPrice
      this.editedNewItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedNewItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedNewItem.Type = val.Type
      await this.getTempStockByItemNumber()
      this.editedNewItem.TempStockQuantity = this.tempStock.CurrentQuantity
      this.editedNewItem = JSON.parse(JSON.stringify(this.editedNewItem))
    },
    setEditedMoveItem (val) {
      this.editedMoveItem.Id = val.Id
      this.editedMoveItem.Number = val.Number
      this.editedMoveItem.Name = val.Name
      this.editedMoveItem.Unit = val.Unit
      this.editedMoveItem.Price = val.Price
      this.editedMoveItem.IsMonthItem = val.IsMonthItem
      this.editedMoveItem.IsDelete = val.IsDelete
      this.editedMoveItem.StoreNo = val.StoreNo
      this.editedMoveItem.RepairPrice = val.RepairPrice
      this.editedMoveItem.RepairWarrantyPeriod = val.RepairWarrantyPeriod
      this.editedMoveItem.RentWarrantyPeriod = val.RentWarrantyPeriod
      this.editedMoveItem.WarrantyPeriod = val.WarrantyPeriod
      this.editedMoveItem.HasSerialNumber = val.HasSerialNumber
      this.editedMoveItem.Type = val.Type
      this.editedMoveItem.BuyOrRentType =
        val.Type === 'Z100000000' ? 2 : this.editedMoveItem.BuyOrRentType
      this.editedMoveItem = JSON.parse(JSON.stringify(this.editedMoveItem))
    },
    turnData (value) {
      if (value) {
        return ItemInstallPositionType.getFormInstallPositionTypeName(
          value,
          this.allInstallPositionType
        )
      }
    },
    async getAllInstallPositionType () {
      let response = await HttpInstallPosition.GetAllInstallPosition()
      this.allInstallPositionType = response.status === 200 ? response.data.Data : []
    },
    async getBuyOrRentType () {
      let response = await HttpInstallationAcceptance.GetBuyOrRentTypes()
      this.allBuyOrRentType = response.status === 200 ? response.data.Data : []
    },
    async getCustomerDeviceType () {
      let response = await HttpQuotation.GetCustomerDeviceType()
      this.customerDeviceTypeList = response.status === 200 ? response.data.Data : 0
    },
    changeIsCustomerDevice () {
      if (this.editedMoveItem.IsCustomerDevice) {
        this.editedMoveItem.CustomerDeviceType = 3
      } else {
        this.editedMoveItem.CustomerDeviceType = 0
      }

      if (this.editedMoveCarBomItem.IsCustomerDevice) {
        this.editedMoveCarBomItem.CustomerDeviceType = 3
      } else {
        this.editedMoveCarBomItem.CustomerDeviceType = 0
      }

      if (this.editedNewItem.IsCustomerDevice) {
        this.editedNewItem.CustomerDeviceType = 3
      } else {
        this.editedNewItem.CustomerDeviceType = 0
      }
    },
    convertToDateTimeFormat (timestamp) {
      if (timestamp === 0) {
        return '-'
      } else {
        return this.$moment(new Date(timestamp)).format('YYYY-MM-DD')
      }
    },
    isShowEditNewItemDialogBtn (item, mainIndex, subIndex) {
      if (!item.Number || item.Number === '') {
        this.editedNewItemIndex = mainIndex
        this.editedNewItem = JSON.parse(JSON.stringify(item))
        this.isShowEditNewItemBomDialog = true
      } else {
        this.editedNewBomItemIndex = subIndex
        this.editedNewItemIndex = mainIndex
        this.editedNewItem = JSON.parse(JSON.stringify(item))
        this.isShowEditNewItemDialog = true
      }
    },
    async saveEditedNewItem () {
      const isValid = await this.$refs.dialogItem.validate()
      if (isValid) {
        if (this.editedNewItem.subIndex !== -1) {
          this.$emit('setNewBomItemIndex', this.editedNewBomItemIndex)
          this.$emit('setNewItemIndex', this.editedNewItemIndex)
        } else {
          this.$emit('setNewItemIndex', this.editedNewItemIndex)
        }

        this.$emit('setEditedNewItem', this.editedNewItem)
        this.closeEditedNewItem()
      }
    },
    closeEditedNewItem () {
      this.isShowEditNewItemDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultNewItem)
        this.editedNewItem = JSON.parse(str)
        this.editedNewItemIndex = -1
        this.editedNewBomItemIndex = -1
        this.computedTotalQuantity = 0
        this.computedTotalPrice = 0
      })
    },
    async saveEditedNewItemBom () {
      const isValid = await this.$refs.dialogBom.validate()
      if (this.editedNewItem.Name.Name) {
        this.editedNewItem.Name = this.editedNewItem.Name.Name
      }
      if (isValid) {
        this.$emit('setNewItemIndex', this.editedNewItemIndex)
        this.$emit('setNewBomItemIndex', this.editedNewBomItemIndex)
        let response = await HttpBom.GetBomById({ bomId: this.editedNewItem.Id })
        let errorMassage = ''
        if (response && response.status === 200) {
          let bom = response.status === 200 ? response.data.Data : {}
          if (bom) {
            this.editedNewItem.BomItems.forEach((element, index) => {
              let bomItem = bom.BomItems.find((x) => x.Id === element.Id)
              if (bomItem) {
                element.IsCustomerDevice = this.editedNewItem.IsCustomerDevice
                element.CustomerDeviceType = this.editedNewItem.CustomerDeviceType
                element.Quantity = this.editedNewItem.Quantity * bomItem.Quantity * 1
                if (element.Type === 'Z100000000') {
                  element.BuyQuantity = 0
                  element.RentQuantity =
                    this.editedNewItem.BuyQuantity * 1 + this.editedNewItem.RentQuantity * 1
                } else {
                  element.BuyQuantity = this.editedNewItem.BuyQuantity * 1
                  element.RentQuantity = this.editedNewItem.RentQuantity * 1
                }
                element.TotalQuantity =
                  element.Quantity * (element.BuyQuantity + element.RentQuantity)
                element.InstallPositions = this.editedNewItem.InstallPositions
                if (index === 0) {
                  element.Discount = this.editedNewItem.Discount
                  element.DiscountPrice = element.Price - element.Discount
                  element.TotalPrice = element.DiscountPrice * element.TotalQuantity
                } else {
                  element.Discount = 0
                  element.DiscountPrice = element.Price
                  element.TotalPrice = element.Price * element.TotalQuantity
                }
              } else {
                errorMassage += 'Bom表Item: 【' + element.Id + ' 】無此Item'
              }
            })
            this.$emit('setEditedNewItem', this.editedNewItem)
            this.closeEditedNewItemBom()
          } else {
            errorMassage = 'BOMId: 【' + this.editedNewItem.Id + ' 】無此BOM'
          }
        } else {
          errorMassage = '取得BOM失敗'
        }
        if (errorMassage) {
          alert(errorMassage)
        }
      }
    },
    closeEditedNewItemBom () {
      this.isShowEditNewItemBomDialog = false
      this.$nextTick(() => {
        let str = JSON.stringify(this.defaultNewItem)
        this.editedNewItem = JSON.parse(str)
        this.editedNewItemIndex = -1
        this.editedNewBomItemIndex = -1
        this.computedTotalQuantity = 0
        this.computedTotalPrice = 0
      })
    },
    isShowDeleteNewItemDialogBtn (item, mainIndex, subIndex) {
      if (!item.Number) {
        this.editedNewItemIndex = mainIndex
        this.isShowDeleteNewItemBomDialog = true
      } else {
        this.editedNewBomItemIndex = subIndex
        this.editedNewItemIndex = mainIndex
        this.isShowDeleteNewItemDialog = true
      }
    },
    confirmDeleteNewItem () {
      if (this.editedMoveItem.subIndex !== -1) {
        this.$emit('setNewBomItemDeleteIndex', this.editedNewBomItemIndex)
        this.$emit('setNewItemDeleteIndex', this.editedNewItemIndex)
      } else {
        this.$emit('setNewItemDeleteIndex', this.editedNewItemIndex)
      }
      this.closeDeleteNewItem()
    },
    closeDeleteNewItem () {
      this.isShowDeleteNewItemDialog = false
      this.$nextTick(() => {
        this.editedNewItemIndex = -1
        this.editedNewBomItemIndex = -1
      })
    },
    confirmDeleteNewItemBom () {
      this.$emit('setNewBomItemDeleteIndex', this.editedNewBomItemIndex)
      this.$emit('setNewItemDeleteIndex', this.editedNewItemIndex)
      this.closeDeleteNewItemBom()
    },
    closeDeleteNewItemBom () {
      this.isShowDeleteNewItemBomDialog = false
      this.$nextTick(() => {
        this.editedNewItemIndex = -1
        this.editedNewBomItemIndex = -1
      })
    },

    isShowEditedMoveItemDialogBtn (item) {
      this.editedMoveItemIndex = this.computedMoveItemList.indexOf(item)
      this.editedMoveItem = JSON.parse(JSON.stringify(item))
      this.isShowMoveItemDialog = true
    },
    async saveEditedMoveItem () {
      const isValid = await this.$refs.dialog.validate()
      if (isValid) {
        this.$emit('setMoveItemIndex', this.editedMoveItemIndex)
        this.$emit('setEditedMoveItem', this.editedMoveItem)
        this.closeEditedMoveItem()
      }
    },
    closeEditedMoveItem () {
      this.isShowMoveItemDialog = false
      this.$nextTick(() => {
        this.editedMoveItem = JSON.parse(JSON.stringify(this.defaultMoveItem))
        this.editedMoveItemIndex = -1
      })
    },
    isShowDeleteMoveItemDialogBtn (item) {
      this.editedMoveItemIndex = this.computedMoveItemList.indexOf(item)
      this.isShowDeleteMoveItemDialog = true
    },
    confirmDeleteReturnItem () {
      this.$emit('setMoveItemDeleteIndex', this.editedMoveItemIndex)
      this.closeDeleteReturnItem()
    },
    closeDeleteReturnItem () {
      this.isShowDeleteMoveItemDialog = false
      this.$nextTick(() => {
        this.editedMoveItemIndex = -1
      })
    },

    setEditedPayItem (val) {
      this.editedPayItem.Id = val.Id
      this.editedPayItem.Number = val.Number
      this.editedPayItem.Name = val.Name
      this.editedPayItem.Unit = val.Unit
      this.editedPayItem.Price = val.Price
      this.editedPayItem.IsDelete = val.IsDelete
      this.editedPayItem.StoreNo = val.StoreNo
      this.changePayTotal()
      this.editedPayItem = JSON.parse(JSON.stringify(this.editedPayItem))
    },
    closeEditedPayItem () {
      this.isShowEditPayItemDialog = false
      this.editedPayItem = JSON.parse(JSON.stringify(this.defaultPayItem))
      this.editedPayItemIndex = -1
    },
    openPayItem () {
      this.editedPayItem.BuyQuantity = this.carQuantity
      this.isShowEditPayItemDialog = true
    },
    isShowEditPayItemDialogBtn (item) {
      this.editedPayItemIndex = this.payItemList.indexOf(item)
      this.editedPayItem = JSON.parse(JSON.stringify(item))
      this.isShowEditPayItemDialog = true
    },
    async saveEditedPayItem () {
      const isValid = await this.$refs.dialogPayItem.validate()
      if (isValid) {
        this.$emit('setPayItemIndex', this.editedPayItemIndex)
        this.$emit('setPayItem', this.editedPayItem)
        this.closeEditedPayItem()
      }
    },
    isShowDeletePayItemDialogBtn (item) {
      this.editedPayItemIndex = this.payItemList.indexOf(item)
      this.isShowDeletePayItemDialog = true
    },
    closeDeletePayItem () {
      this.editedPayItemIndex = -1
      this.isShowDeletePayItemDialog = false
    },
    confirmDeletePayItem () {
      this.$emit('deletePayItem', this.editedPayItemIndex)
      this.closeDeletePayItem()
    },

    setDiscountItemIndex (index) {
      this.$emit('setDiscountItemIndex', index)
    },
    setDiscountItem (val) {
      this.$emit('setDiscountItem', val)
    },
    deleteDiscountItem (index) {
      this.$emit('deleteDiscountItem', index)
    },
    setAllDiscount (temp) {
      this.$emit('setAllDiscount', temp)
    },

    setAllMoveMonth (temp) {
      this.$emit('setAllMoveMonth', temp)
    },
    setMonthItemIndex (index) {
      this.$emit('setMonthItemIndex', index)
    },
    setMoveMonthItem (val) {
      this.$emit('setMoveMonthItem', val)
    },
    deleteMoveMonthItem () {
      this.$emit('deleteMoveMonthItem')
    },
    async getTempStockByItemNumber () {
      let response = await HttpTempStock.GetTempStockByItemNumber({
        itemNumber: this.editedNewItem.Number
      })
      this.tempStock =
        response && response.status === 200 && response.data.Data
          ? JSON.parse(JSON.stringify(response.data.Data))
          : {}
    }
  },
  props: [
    'moveItemList',
    'fatherNewItemList',
    'isAllTextFieldDisabled',
    'monthItemList',
    'payItemList',
    'carQuantity',
    'repairCustomerId',
    'discountItemList',
    'allPayType',
    'allPayQuantityType',
    'fatherTempStockList'
  ]
}
</script>
